<template>
    <component :is="element" :class="['heading', size]" >
        <slot/>
    </component>
</template>

<script>
export default {
    name: 'heading',
    props: {
        level: {
            type: String,
            default: 'h1',
        },
    },
    computed: {
        element() {
            if (['h1', 'h2', 'h3', 'h4', 'h5'].includes(this.level)) {
                return this.level;
            }
            return 'h1';
        },
        size() {
            if (['h1', 'h2', 'h3', 'h4', 'h5'].includes(this.level)) {
                return '';
            }
            return this.level;
        },
    },
};
</script>

<style lang="scss">
@import 'global/default';

.heading {
    color: $color-neutral-dark-500;
}

h1.heading {
    font-size: $font-size-h1;
    font-weight: $font-weight-extra-bold;
    line-height: 1.2;
}
h1.title {
    font-size: $font-size-title;
    font-weight: $font-weight-extra-bold;
}
h1.subtitle {
    font-size: $font-size-subtitle;
    font-weight: $font-weight-medium;
}
h2.heading {
    font-size: $font-size-h2;
    font-weight: $font-weight-bold;
}
h3.heading {
    font-size: $font-size-h3;
    font-weight: $font-weight-bold;
}
h4.heading {
    font-size: $font-size-h4;
    font-weight: $font-weight-semi-bold;
}
h5.heading {
    font-size: $font-size-h5;
    font-weight: $font-weight-medium;
}

</style>
